// @flow

export type MostRecentPin = {
  type: 'MOST_RECENT_PIN',
  payload: {
    id: ?string,
  },
};

export const setMostRecentPin = (id: ?string): MostRecentPin => ({
  type: 'MOST_RECENT_PIN',
  payload: {
    id,
  },
});

export type MostRecentPLP = {
  type: 'MOST_RECENT_PLP',
  payload: {
    plpPinId: ?string,
  },
};

export const setMostRecentPLP = (plpPinId: ?string): MostRecentPLP => ({
  type: 'MOST_RECENT_PLP',
  payload: {
    plpPinId,
  },
});

export type MostRecentPinImage = {
  type: 'MOST_RECENT_PIN_IMAGE',
  payload: {
    image_signature: ?string,
  },
};

export const setMostRecentPinImage = (image_signature: ?string): MostRecentPinImage => ({
  type: 'MOST_RECENT_PIN_IMAGE',
  payload: {
    image_signature,
  },
});

export default undefined;
